import { useFinancialStatementRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetFinancialStatementCommonInfoQuery } from "../../features/api/financialStatementApi";
import { FsType } from "../../entities/enums";
import { memo } from "react";

export { useFinancialStatementRoutes };

interface FinancialStatementsProps {
  fsType: FsType;
}

const FinancialStatements = memo(({ fsType }: FinancialStatementsProps) => {
  let title = "";
  switch (fsType) {
    case FsType.ProfitAndLoss:
      title = "صورت های سود و زیان";
      break;
    case FsType.BalanceSheet:
      title = "ترازنامه";
      break;
    case FsType.CashFlow:
      title = "صورت های نقدی";
      break;
    case FsType.ConsolidatedProfitAndLoss:
      title = "صورت های سود و زیان تلفیقی";
      break;
    case FsType.ConsolidatedBalanceSheet:
      title = "ترازنامه  تلفیقی";
      break;
    case FsType.ConsolidatedCashFlow:
      title = "صورت های نقدی  تلفیقی";
      break;
  }

  return GetDefaultIndex({
    title: title,
    query: useGetFinancialStatementCommonInfoQuery,
    queryArgs: fsType,
  })();
});

export default FinancialStatements;
